import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { trackPageView, trackViewContent } from "@/lib/tracking";
import { ScrollProgress } from "@/components/landing/ScrollProgress";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { StickyCTA } from "@/components/landing/StickyCTA";
import { SocialProof } from "@/components/landing/SocialProof";
import { Benefits } from "@/components/landing/Benefits";
import { Features } from "@/components/landing/Features";
import { Comparison } from "@/components/landing/Comparison";
import { ValueCalculator } from "@/components/landing/ValueCalculator";
import { Urgency } from "@/components/landing/Urgency";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Advantages } from "@/components/landing/Advantages";
import { Testimonials } from "@/components/landing/Testimonials";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import CapCutPage from "@/pages/CapCut";

function GeminiLanding() {
  useEffect(() => {
    document.title = "Google Gemini Pro 18 Bulan Rp79.000 — HotaroDigital";
    trackViewContent();
  }, []);

  return (
    <div className="font-body text-slate-900 bg-white">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Benefits />
        <Features />
        <Comparison />
        <ValueCalculator />
        <Urgency />
        <HowItWorks />
        <Advantages />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
      <SocialProof />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    if (window.location.pathname.indexOf("/capcut") !== 0) {
      trackPageView();
    }
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GeminiLanding />} />
          <Route path="/capcut" element={<CapCutPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
